export const HS_PAYMENTS = 'HS_PAYMENTS';
export const BYO_STRIPE = 'BYO_STRIPE';
export type ProcessorType = typeof HS_PAYMENTS | typeof BYO_STRIPE;
